import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { GqlError } from './GqlError';
import { CloseActiveUserSessionsInput, CloseActiveUserSessionsPayload } from './generated/types';

const mutation = `mutation CloseActiveUserSessions($input: CloseActiveUserSessionsInput!) {
    closeActiveUserSessions(input: $input) {
        closedSessionsCount
        succeeded
    }
}`;

interface CloseActiveUserSessionsResponseBody {
    data: {
        closeActiveUserSessions: CloseActiveUserSessionsPayload;
    };
    errors?: Array<GqlError>;
}

export const useCloseUserSessions = () => {
    const context = useContext(AppContext);

    return useMutation({
        mutationFn: async (input: CloseActiveUserSessionsInput) => {
            const { data } = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<CloseActiveUserSessionsResponseBody>);

            return data.closeActiveUserSessions;
        },
    });
};
